var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3785(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "gray",
    width: 30.726,
    height: 25.923,
    viewBox: "0 0 30.726 25.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3785",
    "data-name": "Group 3785",
    transform: "translate(457.41 -129.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M-446.863,134.677v1.917h-.326q-3.135,0-6.271,0a1.92,1.92,0,0,0-2.031,2.028q0,6.616,0,13.232a1.921,1.921,0,0,0,2.033,2.027h22.833a1.92,1.92,0,0,0,2.023-2.008q0-6.631,0-13.262a1.918,1.918,0,0,0-2.013-2.017q-3.645,0-7.291,0h-.287a4.2,4.2,0,0,1-.61,2.051,3.859,3.859,0,0,1-4.017,1.714,3.834,3.834,0,0,1-3.014-3.188,4.747,4.747,0,0,1-.05-.656q-.006-2.775,0-5.551a.975.975,0,0,1,1.094-1.087h5.491a.979.979,0,0,1,1.092,1.09q0,1.68,0,3.36v.35h.382q3.615,0,7.231,0a3.82,3.82,0,0,1,3.814,3.018,3.613,3.613,0,0,1,.092.8q.008,6.736,0,13.472a3.834,3.834,0,0,1-3.839,3.828q-11.521,0-23.042,0a3.834,3.834,0,0,1-3.838-3.829q-.006-6.736,0-13.472a3.833,3.833,0,0,1,3.819-3.817C-451.358,134.673-449.128,134.677-446.863,134.677Zm3.363.961a1.431,1.431,0,0,0,1.464,1.45,1.431,1.431,0,0,0,1.442-1.441,1.43,1.43,0,0,0-1.449-1.465A1.43,1.43,0,0,0-443.5,135.638Z",
    transform: "translate(0 0)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    d: "M-172.98,421.306H-182.2a4.563,4.563,0,0,1,4.288-3.594A4.593,4.593,0,0,1-172.98,421.306Z",
    transform: "translate(-258.693 -270.555)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M-372.634,385.873q1.874,0,3.748,0a.971.971,0,0,1,1.052.949.967.967,0,0,1-1.035.966q-3.763,0-7.526,0a.964.964,0,0,1-.968-1.315.967.967,0,0,1,.951-.6Q-374.523,385.871-372.634,385.873Z",
    transform: "translate(-75.175 -240.634)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    d: "M-373.058,337.873q1.634,0,3.268,0a.971.971,0,0,1,1.053.948.973.973,0,0,1-1.064.967q-3.253,0-6.506,0a.973.973,0,0,1-1.067-.964.973.973,0,0,1,1.078-.952Z",
    transform: "translate(-75.232 -195.515)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M-138.291,339.077a2.1,2.1,0,0,1-2.09-2.1,2.1,2.1,0,0,1,2.122-2.1,2.1,2.1,0,0,1,2.075,2.115A2.1,2.1,0,0,1-138.291,339.077Z",
    transform: "translate(-298.003 -192.702)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M-374.059,435.786c-.759,0-1.519,0-2.278,0a.969.969,0,0,1-1.037-.964.967.967,0,0,1,1.048-.951q2.308,0,4.616,0a.971.971,0,0,1,1.053.948.973.973,0,0,1-1.064.967Q-372.89,435.788-374.059,435.786Z",
    transform: "translate(-75.232 -285.75)",
    fill: "gray"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3785);
export default __webpack_public_path__ + "static/media/Group 3785.4dc1df34433efb742e4be1d1f119f651.svg";
export { ForwardRef as ReactComponent };